import { createInventoryAsyncResponse } from "./types";
import * as inventoryActions from "./inventories.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiPost, API_URL_INVENTORY, retrieveToken } from "../../../helpers/api";

export function* createInventory(action: ReturnType<typeof inventoryActions.createInventoryAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiPost, API_URL_INVENTORY.CREATE_INVENTORY, token, action.payload);
    if (result.status === 200) {
      const parsed: createInventoryAsyncResponse = yield call(result.json.bind(result));
      yield put(inventoryActions.createInventoryAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(inventoryActions.createInventoryAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(inventoryActions.createInventoryAsync.failure(parsed));
  }
}

export default function* inventoriesSagaCreateInventory() {
  yield takeEvery(inventoryActions.createInventoryAsync.request, createInventory);
}
